/** Mena vsetkych modelov, ktore sa pouzivaju v minihre */
export enum ModelsNames {

  athlete = 'athlete',
  env = 'env',
  envDynamic = 'envDynamic',
  trackLines = 'trackLines',
  stadium = 'AthleticStadium',
  cameraBoxes = 'cameraBoxes'

}

/** Mena vsetkych textur, ktore sa pouzivaju v minihre */
export enum TexturesNames {

  athleteRacePrefix = 'athlete_race_',
  athleteRaceWhiteMan = 'male/athlete_race_white',
  athleteRaceMulattoMan = 'male/athlete_race_mulatto',
  athleteRaceBlackMan = 'male/athlete_race_black',
  athleteRaceWhiteWoman = 'female/athlete_race_white',
  athleteRaceMulattoWoman = 'female/athlete_race_mulatto',
  athleteRaceBlackWoman = 'female/athlete_race_black',
  athleteClothes = 'athlete_clothes',
  athleteHairMan = 'male/athlete_hair',
  athleteHairWoman = 'female/athlete_hair',
  javelin = 'javelin',
  audience = 'audience512v',
  colorGradient = 'ColorGradientAds2048v',
  colorGradientVshosting = 'ColorGradientAdsVshosting2048',
  concrete = 'CleanConcrete512',
  glassPanel = 'GlassPanel512',
  grass = 'Grass512',
  ground = 'GroundTexture512',
  hexCladding = 'HexCladding512',
  lights = 'Lights512',
  metal = 'MetalDetail512',
  panel = 'Panel512',
  sand = 'Sand512',
  seats = 'Seats512v',
  stairs = 'Stairs512',
  texts = 'Texts1024v',
  lattice = 'Lattice512',
  emissive = 'Emissive512',
  flagsImages = 'FlagsImages2048v',
  flagsTexts = 'FlagsTexts2048v',
  gradient = 'Gradient64',
  numbers = 'NumbersTemp512',
  npc = 'NPC512',
  lightFlashes = 'LightFlashes512',
  envLightmap = 'EnvLightmap2048v',
  skybox = 'Skybox2048v'

}

/** Mena vsetkych materialov, ktore sa pouzivaju v minihre */
export enum MaterialsNames {

  athlete = 'athlete',
  athleteHairTrack = 'athleteHairTrack',
  athleteHairClip = 'athleteHairClip',
  javelin = 'javelin',
  audience = 'audience',
  audienceFlags = 'audienceFlags',
  colorGradient = 'colorGradient',
  concrete = 'concrete',
  glassPanel = 'glassPanel',
  grass = 'grass',
  ground = 'ground',
  hexCladding = 'hexCladding',
  lights = 'lights',
  metal = 'metal',
  panel = 'panel',
  camera = 'camera',
  sand = 'sand',
  seats = 'seats',
  stairs = 'stairs',
  npc = 'npc',
  texts = 'texts',
  texts2 = 'texts2',
  lattice = 'lattice',
  emissive = 'emissive',
  numbers = 'numbers',
  lightFlashes = 'lightFlashes',
  lightsGradient = 'lightGradient',
  onlyVertexColors = 'onlyVertexColors',
  lineRecord = 'lineRecord',

}

/** Mena vsetkych animacii hraca */
export enum PlayerAnimationsNames {

  happy1 = 'happy 1',
  happy2 = 'happy 2',
  happy3 = 'happy 3',
  intro1 = 'intro 1',
  intro2 = 'intro 2',
  intro3 = 'intro 3',
  intro4 = 'intro 4',
  intro4_1 = 'intro 4-1',
  neutral1 = 'neutral 1',
  neutral2 = 'neutral 2',
  prepare = 'prepare',
  run = 'run',
  runStop = 'run stop',
  sad1 = 'sad 1',
  sad2 = 'sad 2',
  throw1 = 'thorow+stop 1',
  throw2 = 'thorow+stop 2',
  throw3 = 'thorow+stop 3',
  windUp = 'wind up'

}

/**
 * Specialne data z init requestu
 */
export interface SpecialDataFromInit {

  nothing: unknown

}

/** Farby pre lidra */
export enum LeaderColors {

  green = 0,
  lightBlue = 1

}

/** Rozne eventy */
export enum CustomGameEvents {

  playerFinished = 'playerFinished'

}
